import * as apiEndPoints from "../../shared/apiPaths";
import { getErrorMessage } from "../../shared/utils";
import axios from "axios";
import * as actionTypes from "./actionTypes";

export const getDropdownValues = (screenId, token) => {
  return dispatch => {
    dispatch(getDropdownValuesRequest());

    const url =
      window.ENV.API_ROOT + apiEndPoints.DROPDOWNVALUES;
    const config = {
      headers: { Authorization: token.token  } 
    };

    const data = {
      screenId: screenId
    };

    axios
      .post(url, data, config)
      .then(response => {
        let dropdownValues = null;
        dropdownValues= response.data; 
        dispatch(getDropdownValuesSuccess(dropdownValues));
      })
      .catch(error => {
        dispatch(getDropdownValuesFailure(getErrorMessage(error)));
      });
    
  };
};
 
  const getDropdownValuesRequest = () => {
    return {
      type: actionTypes.DROPDOWNVALUES_REQUEST
    };
  };

  const getDropdownValuesFailure = error => {
    return {
      type: actionTypes.DROPDOWNVALUES_FAILURE,
      error: error
    };
  };
  
  const getDropdownValuesSuccess = response => {
    return {
      type: actionTypes.DROPDOWNVALUES_SUCCESS,
      response: response
    };
  };
